class VerifyVideo
  constructor: (@checkbox) ->
    form_div = $("div[data-behavior=VerifyVideo]")
    @checkbox.change ->
      if $(this).prop('checked')
        form_div.show("slowly")
      else
        form_div.hide("slowly")

ready_video = ->
  $("input[type='checkbox'][data-behavior=VerifyVideo]").each ->
    new VerifyVideo($(@))

$(document).ready(ready_video)
$(document).on('turbo:load', ready_video)
